// Pie de página: "© <year> FacturaDirecta". Se renderiza dentro del
// form-container, debajo de cada pantalla. Idéntico al legacy.

export function Footer() {
  return (
    <footer className="text-center">
      © {new Date().getFullYear()} FacturaDirecta
    </footer>
  );
}
